"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOperationNameBySegment = void 0;
const constants_1 = require("./constants");
const operationsTranslation = {
    'fixter-c&d': {
        [constants_1.Segment.Fixter_UK]: 'Collection & Delivery',
        [constants_1.Segment.Fixter_FR]: 'Collecte et restitution',
    },
};
const getOperationNameBySegment = (sku, segment) => {
    return operationsTranslation[sku]?.[segment];
};
exports.getOperationNameBySegment = getOperationNameBySegment;
//# sourceMappingURL=operations.js.map